import { variables } from '../common/variables';

import { cl } from '../common/functions';

const resetLocation = (map, group) => {
  let leafletControlContainer = document.querySelector('.leaflet-top.leaflet-left');
  if (leafletControlContainer !== null) {
    let resetLocationElement = `<div class="leaflet-control-resetLocation leaflet-bar leaflet-control">
    <a class="leaflet-control-resetLocation-button leaflet-bar-part" title="vue globale"></a>
    </div>`;
    leafletControlContainer.insertAdjacentHTML('beforeend', resetLocationElement);
    let resetLocationButton = document.querySelector('.leaflet-control-resetLocation-button');
    if (resetLocationButton !== null) {
      // prettier-ignore
      resetLocationButton.addEventListener('click', () => {
        map.fitBounds(group.getBounds().pad(0));
      }, false);
    }
  }
};

export { resetLocation };
